import { render, staticRenderFns } from "./ShowDetails.vue?vue&type=template&id=623c748f&"
import script from "./ShowDetails.vue?vue&type=script&lang=js&"
export * from "./ShowDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports